
import { Mixin } from 'vue-mixin-decorator';
import Vue from 'vue';

@Mixin
class ErrorMixin extends Vue {

    public error: any = {};

    public hideError(prop: string): void {
        (this.error as any)[prop] = '';
    }

}

export default ErrorMixin;
